import classNames from "classnames";
import { SvgProps, useStyleSVG } from "./_styleIcon";

function SvgKeyboardArrowDown({ className, ...props }: SvgProps) {
  const classes = useStyleSVG();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}
      className={classNames(classes.svg, className)}
    >
      <path fill="rgba(0,0,0,0)" d="M0 0h24v24H0z" />
      <path
        d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgKeyboardArrowDown;
